import { useState } from 'react'

/** Solid (filled) person silhouette — the no-photo avatar fallback. White
 *  fill (inherits the avatar's `text-white`) on the navy gradient, matching
 *  the design reference. */
function PersonIcon({ size }) {
  const px = Math.round(size * 0.66)
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  )
}

/**
 * Small round account avatar — the Google/S3 photo when available, with a
 * filled person-icon fallback (and graceful degrade if the image 404s).
 * Shared by the account switcher and the sign-in account pickers so all
 * surfaces render an identical avatar. `size` is the pixel diameter.
 */
export function AccountAvatar({ name, avatarUrl, size = 32 }) {
  const [broken, setBroken] = useState(false)
  const showImg = avatarUrl && !broken
  return (
    <span
      className="shrink-0 rounded-full bg-gradient-to-br from-[#006CA5] to-[#02367B] text-white flex items-center justify-center overflow-hidden"
      style={{ width: size, height: size }}
    >
      {showImg ? (
        <img
          src={avatarUrl}
          alt={name || ''}
          className="h-full w-full object-cover"
          draggable={false}
          // Google profile photos 403 with a cross-origin referrer.
          referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
        />
      ) : (
        <PersonIcon size={size} />
      )}
    </span>
  )
}
